import Api from "../config/Axios";

// export const createstore = (data) => {
//   return Api.post("api/web/store/create", data);
// };

export const getstoreList = () => {
  return Api.get("api/web/store/list");
};

export const getSingleStore = (shiftId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/store/"+shiftId, config);
};
